import NotificationStub from './NotificationStub';

export default NotificationStub;
